<template>
<div id="app">
  <div class="wrapper">
    <Header />
    <div class="content">
      <div class="left-content">
        <SideMenu />
      </div>
      <div class="main-content">
        <router-view />
        <div class="bottom-content">
          <Footer />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

import Header from '@/components/Header.vue'
import SideMenu from '@/components/SideMenu.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    SideMenu,
    Footer
  }
}
</script>

<style lang="scss">
@import "./src/assets/css/style.scss";
@import "./src/assets/css/modal.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue